import { Badge } from "@/components/ui";
import { Button } from "@/components/ui/Button";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/Select";
import { BodyText } from "@/components/ui/Text";
import { useState } from "react";
import type { CodifiedMedication } from "./useAmazonVisitIntake";

export const CiqMedicationPopover = ({
  drugs,
  onAdd,
  isPending,
  addedDrug,
  pendingDrugName,
}: {
  drugs: CodifiedMedication[];
  onAdd: (drug: CodifiedMedication) => void;
  isPending: boolean;
  addedDrug?: CodifiedMedication;
  pendingDrugName?: string;
}) => {
  const [value, setValue] = useState("");

  if (isPending) {
    return (
      <div className="mt-1 flex items-center justify-between gap-2 w-full px-2 h-8 border border-transparent rounded-lg">
        <BodyText size="sm">{pendingDrugName}</BodyText>
        <Button
          size="xs"
          type="button"
          isLoading={true}
          className="shrink-0 transition-none bg-button-superclinical text-button-primary border border-ai"
        >
          Add
        </Button>
      </div>
    );
  }

  if (addedDrug) {
    return (
      <div className="mt-1 flex items-center justify-between gap-2 w-full px-2 h-8 border border-transparent rounded-lg">
        <BodyText size="sm">{addedDrug.drugName}</BodyText>
        <div className="flex items-center shrink-0" style={{ height: 25 }}>
          <Badge variant="ai">
            <BodyText size="xs">Added</BodyText>
          </Badge>
        </div>
      </div>
    );
  }

  return (
    <Select
      value={value}
      onValueChange={(drugCode) => {
        setValue("");
        const drug = drugs.find((d) => String(d.drugCode) === drugCode);
        if (drug) onAdd(drug);
      }}
    >
      <SelectTrigger className="mt-1">
        <SelectValue placeholder="Select to add..." />
      </SelectTrigger>
      <SelectContent scrollMode="scrollbar">
        {drugs.map((drug) => (
          <SelectItem key={drug.drugCode} value={String(drug.drugCode)}>
            {drug.drugName}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};
